<template>
    <div class="portfolio-edit-header">
        <b-button
            class="btn-medal btn-portfolio-rating"
            v-if="groupIn.permissions.can_edit_portfolio"
            v-b-modal="'portfolio-rating'"
            variant="primary-icon"
            :v-b-tooltip="$t('portfolio.review_portfolio')">
        </b-button>

        <b-button
            class="btn-publish-portfolio"
            id="portfolio-publish-toggle"
            :class="!!haveUnPublishedAssignment ? 'btn-eye-closed' : 'btn-eye'"
            @click="portfolioPublish"
            :variant="!!haveUnPublishedAssignment ? 'danger-icon' : 'primary-icon'">
        </b-button>

        <b-button class="btn-worldmap-portfolio" :class="!!(portfolioIn.worldmap) ? 'btn-globe' : 'btn-list'"
                  id="portfolio-worldmap-toggle" @click="toggleWorldmap"
                  :variant="!!(portfolioIn.worldmap) ? 'success-icon' : 'primary-icon'">
            <!--            Todo: @Chuku add btn-globe properly -->
        </b-button>

        <b-tooltip
            target="portfolio-publish-toggle"
            placement="top">
            {{
                !!haveUnPublishedAssignment
                    ? $t('portfolio.publish_all_assignments')
                    : $t('portfolio.withdraw_publication_for_all_assignments')
            }}
        </b-tooltip>

        <b-button
            class="btn-tags btn-portfolio-tags"
            v-if="groupIn.permissions.can_edit_portfolio"
            v-b-modal="'portfolio-tags-management-modal'"
            variant="primary-icon"
            :v-b-tooltip="$t('portfolio.edit_tags')">
        </b-button>

        <design-2021-portfolio-edit-update-name-modal-component
            :portfolio="portfolio"
            :key="portfolio.id">
        </design-2021-portfolio-edit-update-name-modal-component>

        <design-2021-portfolio-edit-rating-modal-component
            :show-grade-options="true"
            :object-in="portfolio"
            grade-target="categories"
            key-name="portfolio-rating"
            grade-type="categories"
            :connections="portfolioConnections"
            :title="'Portfolio beoordeling: ' + portfolioIn.name"
            :title-weight="$t('portfolio.category_weighing')"
            @on-save="saveRating($event)">
        </design-2021-portfolio-edit-rating-modal-component>

        <design-2021-portfolio-tags-management-modal-component
            :group-id="groupIn.id"
            @update-tags="updateTags">
        </design-2021-portfolio-tags-management-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-title-component',
    props: ['portfolioIn', 'groupIn'],
    data() {
        return {
            portfolio: this.portfolioIn,
            portfolioConnections: [
                { type: 'categories', name: this.$t('portfolio.categories') },
                { type: 'assignments', name: this.$t('portfolio.assignments') },
                { type: 'subAssignments', name: this.$t('portfolio.partial_assignments') },
            ],
        };
    },
    computed: {
        haveUnPublishedAssignment() {
            for (const category of this.portfolio.categories) {
                for (const assignment of category.assignments) {
                    if (!assignment.publishings.length) {
                        return true;
                    }
                }
            }
            return false;
        },
    },
    methods: {
        showUpdatePortfolioModal() {
            this.$bvModal.show(`update-portfolio-${this.portfolio.id}`);
        },

        portfolioPublish() {
            if (this.haveUnPublishedAssignment) {
                this.publishAssignments();
            } else {
                this.unPublishAssignments();
            }
        },

        publishAssignments() {
            this.alert
                .confirm(
                    this.$t('portfolio.publish'),
                    this.groupIn.children.length
                        ? this.$t(
                              'portfolio.this_group_has_subgroups_if_you_publish_all_assignments_you_will_also_do_it_for_all_subgroups_are_you_sure_you_want_to_do_this',
                          )
                        : this.$t('portfolio.are_you_sure_you_want_to_publish_all_assignments_of_this_portfolio'),
                    'Ja, publiceren',
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        const url =
                            this.routes.baseUrl() +
                            '/portfolio/publishings/' +
                            this.portfolio.id +
                            '/' +
                            this.groupIn.id;
                    window.location.href = url;
                }
            });
        },

        unPublishAssignments() {
            this.alert
                .confirm(
                    this.$t('portfolio.withdraw_publication'),
                    this.groupIn.children.length
                        ? this.$t(
                              'portfolio.this_group_has_subgroups_if_you_withdraw_the_publication_you_will_also_do_this_for_subgroups_are_you_sure_you_want_to_do_this',
                          )
                        : this.$t(
                              'portfolio.are_you_sure_you_want_to_withdraw_the_publication_for_all_assignments_in_this_portfolio',
                          ),
                    this.$t('portfolio.withdraw_publication'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        const url =
                            this.routes.baseUrl() +
                            '/portfolio/unpublishings/' +
                            this.portfolio.id +
                            '/' +
                            this.groupIn.id;
                        window.location.href = url;
                    }
                });
        },

        saveRating(data) {
            this.alert.saving();

            if (!this.portfolio.portfolio_rating) {
                this.axios.post(this.routes.portfolioRating(), data).then(
                    (response) => {
                        // let portfolio = Object.assign({}, this.portfolio);
                        // portfolio.portfolio_rating = response.data.rating;
                        // portfolio.categories = portfolio.categories.map((category) => {
                        //     for (const c of response.data.categories) {
                        //         if (c.id === category.id) {
                        //             let new_category = Object.assign({}, category);
                        //             new_category.portfolio_rating = c.portfolio_rating;
                        //             return new_category;
                        //         }
                        //     }
                        //     return category
                        // });
                        //
                        // this.portfolio = portfolio;
                        // this.alert.success();

                        window.location.href =
                            this.routes.baseUrl() +
                            '/portfolio/publishings/' +
                            this.portfolio.id +
                            '/' +
                            this.groupIn.id;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.axios.post(this.routes.portfolioRatingUpdate(), data).then(
                    (response) => {
                        // let portfolio = Object.assign({}, this.portfolio);
                        // portfolio.portfolio_rating = response.data.rating;
                        // portfolio.categories = portfolio.categories.map((category) => {
                        //     for (const c of response.data.categories) {
                        //         if (c.id === category.id) {
                        //             let new_category = Object.assign({}, category);
                        //             new_category.portfolio_rating = c.portfolio_rating;
                        //             return new_category;
                        //         }
                        //     }
                        //     return category
                        // });
                        //
                        // this.portfolio = portfolio;
                        // this.alert.success();
                        window.location.href =
                            this.routes.baseUrl() +
                            '/portfolio/publishings/' +
                            this.portfolio.id +
                            '/' +
                            this.groupIn.id;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                    );
                }
            },

            updateTags(tags) {
                this.$emit('update-tags', tags);
            },

            toggleWorldmap() {
                if (this.portfolioIn.worldmap) {
                    this.alert
                        .confirm(
                            this.$t('assignment.world_map.turn_off'),
                            this.$t('assignment.world_map.are_you_sure_you_want_to_turn_off_the_world_map_for_this_portfolio'),
                            this.$t('assignment.world_map.yes_turn_off_world_map'))
                        .then((confirm) => {
                            if (confirm) {
                                this.alert.saving();

                                this.axios
                                    .post(this.routes.portfolioCategoryToggleWorldmap(this.portfolioIn.id, this.groupIn.id))
                                    .then(
                                        (response) => {
                                            this.$emit('toggle-worldmap', response.data);
                                        }
                                    );
                            }
                        });
                } else {
                    this.alert
                        .confirm(
                            this.$t('assignment.world_map.turn_on'),
                            this.$t('assignment.world_map.are_you_sure_you_want_to_turn_on_the_world_map_for_this_portfolio'),
                            this.$t('assignment.world_map.yes_turn_on_world_map'))
                        .then((confirm) => {
                            if (confirm) {
                                this.alert.saving();

                                this.axios
                                    .post(this.routes.portfolioCategoryToggleWorldmap(this.portfolioIn.id, this.groupIn.id))
                                    .then(
                                        (response) => {
                                            this.$emit('toggle-worldmap', response.data);
                                        }
                                    );
                            }
                        });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .portfolio-edit-header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        column-gap: map-get($grid-gutter-spacing, 'fifteen');

        > .btn {
            line-height: 1.5;

            &:before {
                margin-right: 0;
            }
        }
    }

    .group-pair-status {
        width: 33.5px;
        height: 37px;
        padding: map-get($grid-gutter-spacing, 'eight');
        font-size: $base-font-size;

        .icon {
            color: $primary;
            filter: grayscale(1);
        }

        &:active {
            .icon {
                color: $success;
                filter: grayscale(0);
            }
        }
    }
</style>
